export const types = {
  SET_CURRENT_USER: 'SET_CURRENT_USER'
} 